var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVrboIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M3.25549 0C3.37153 0.831101 3.53749 1.65443 3.75159 2.46582L6.2301 14H5.67249L3.19397 2.50293C2.86355 1.14407 2.73887 0.528355 2.32581 0.0244141V0H3.25549ZM1.39612 0C1.78443 0.280909 2.23137 0.644517 2.65686 2.61914L5.12268 13.9961H4.56506L2.11584 2.68945C1.75645 1.07423 1.30982 0.383812 0.401001 0.0244141V0H1.39612ZM4.76721 0C4.61851 0.475064 4.53651 1.16955 4.90002 2.68555L6.96545 12.4385L6.59729 13.207L4.2926 2.42871C4.07611 1.63754 3.96991 0.820216 3.97815 0H4.76721ZM6.41174 0V0.0244141C5.89537 0.487084 5.76306 1.29712 6.07288 2.85449L7.72522 10.8809L7.35803 11.6582L5.47815 2.70605C5.1642 1.16524 5.24654 0.582452 5.51917 0H6.41174ZM8.70374 0V0.0244141C7.28301 0.297097 6.86154 1.08652 7.21252 2.89551L8.47327 9.32324L8.1012 10.1045L6.65491 2.8916C6.20476 0.760426 7.01015 0.190106 7.39026 0H8.70374ZM15.5992 0V0.0371094C13.4181 0.69394 12.4548 1.95381 10.7653 5.11816L10.7281 5.09766C12.1905 1.95404 12.889 0.685761 14.0621 0H15.5992ZM13.0006 0V0.0244141C12.4347 0.879533 12.0712 1.79292 10.6832 5.06055L10.6461 5.03613C11.5549 2.54934 11.9922 1.34269 11.8766 0.0332031V0H13.0006Z",
    fill: "#A6A9B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrboIcon);
export default __webpack_public_path__ + "static/media/VRBO_ICON.a2d79cc20e1717b5c6d5743001d3ee4b.svg";
export { ForwardRef as ReactComponent };